import Oauth2Service from '@learnics/services/src/oauth2'
import { auth } from '@learnics/services/src/analyticsConfig'

/**
 * A wrapper around GoogleClassroomService that handles authorization
 * for each of the API calls - specifically for learnics-app.
 */
export async function validateAndRefreshOauth2TokenIfNeeded(
  providerId,
  extraScopes = [],
) {
  let tokenMap = JSON.parse(
    localStorage.getItem(`oauth2Tokens/${auth.currentUser.uid}`) || '{}',
  )
  let token = tokenMap[providerId]
  token = await Oauth2Service.validateAndRefreshTokenIfNeeded(
    providerId,
    extraScopes,
    auth.currentUser.uid,
    token,
  )
  tokenMap = JSON.parse(
    localStorage.getItem(`oauth2Tokens/${auth.currentUser.uid}`) || '{}',
  )
  tokenMap[providerId] = token
  localStorage.setItem(
    `oauth2Tokens/${auth.currentUser.uid}`,
    JSON.stringify(tokenMap),
  )
  return token
}
